import { ButtonProps, IconButton } from '@sc/components/Button'
import { Icon } from '@sc/components/Icon'

export const DeleteButton = (props: ButtonProps) => (
  <IconButton variant="secondary" {...props}>
    <Icon name="close" />
  </IconButton>
)
